/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
var loaded = false;

window.onload = function(e) {
  setTimeout(function() {
    selectBadge();
  }, 700);
  setTimeout(function() {
    selectBadge();
  }, 1500);
};

function selectBadge() {
  if (!loaded) {
    badge = document.querySelector(".spr-badge");

    if (badge) {
      loaded = true;
      badge.onclick = scrollToReview;
    }
  }
}

function scrollToReview() {
  elements = document.querySelectorAll(".Collapsible.Collapsible--large");
  window.scrollTo({
    behavior: "smooth",
    top: elements[elements.length - 1].offsetTop
  });
  button = elements[elements.length - 1].querySelectorAll(
    ".Collapsible__Button"
  );
  button[0].click();
}

$(document).ready(function() {
  var firstTime = true;
  $(".SizeSwatch__Radio").change(function doubleClick(e) {
    if (!firstTime) return;
    firstTime = false;
    var other = $(".SizeSwatch__Radio").not(e.target);
    setTimeout(function() {
      other.click();
      setTimeout(function() {
        e.target.click();
      }, 1);
    }, 1);
  });
  console.log($(".ColorSwatch__Radio"));
  $(".ColorSwatch__Radio").change(function(e) {
    if (!firstTime) return;
    firstTime = false;
    var other = $(".ColorSwatch__Radio").not(e.target);
    other.click();
    setTimeout(function() {
      e.target.click();
    }, 0);
  });

  if ($("#w3-product-accessories").length) {
    var generateAccessory = function generateAccessory(accessory) {
      return '\n\t\t\t\t<div class="modern-accessory" accessory-id="'
        .concat(
          accessory.id,
          '">\n\t\t\t\t\t<input type="checkbox" id="accessory-id-'
        )
        .concat(accessory.id, '"/>\n\t\t\t\t\t<label for="accessory-id-')
        .concat(accessory.id, '">\n\t\t\t\t\t\t<img src="')
        .concat(
          accessory.thumbnail,
          '"/>\n\t\t\t\t\t\t<span class="modern-accessory__price">'
        )
        .concat(
          accessory.price,
          '</span>\n\t\t\t\t\t\t<span class="modern-accessory__title">'
        )
        .concat(
          accessory.title,
          '</span>\n\t\t\t\t\t\t<div class="checkbox">\n\t\t\t\t\t\t\t<i class="dot"/>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t'
        );
    };

    var transformAccessories = function transformAccessories() {
      var accessories = [];
      var nextAccessoryId = 0;
      $("#w3-product-accessories")
        .find(".accessories-item")
        .each(function() {
          var accessoryElement = $(this);
          accessories.push({
            id: nextAccessoryId++,
            title: accessoryElement.find(".accessories-title").text(),
            checkbox: accessoryElement.find('input[type="checkbox"]'),
            price: accessoryElement.find(".accessory-price").text(),
            thumbnail: accessoryElement
              .find(".accessories-img-wrapper img")
              .attr("src")
          });
        });

      for (
        var _i = 0, _accessories = accessories;
        _i < _accessories.length;
        _i++
      ) {
        var accessory = _accessories[_i];
        accessory.html = generateAccessory(accessory);
      }

      var accessoriesHTML = "";

      for (
        var _i2 = 0, _accessories2 = accessories;
        _i2 < _accessories2.length;
        _i2++
      ) {
        var _accessory = _accessories2[_i2];
        accessoriesHTML += _accessory.html;
      }

      $("#modern-accessories").html(
        '\n\t\t\t\t<h3>OFFREZ VOUS UN ACCESSOIRE SUPPL\xC9MENTAIRE</h3>\n        <div class="modern-accessories-container">\n\t\t\t\t    <div class="modern-accessories owl-carousel">'.concat(
          accessoriesHTML,
          "</div>\n        </div>\n\t\t\t"
        )
      );

      var _loop = function _loop() {
        var accessory = _accessories3[_i3];
        var checkbox = $(
          '.modern-accessories div[accessory-id="' + accessory.id + '"]'
        ).find("input");
        checkbox.on("change", function() {
          accessory.checkbox.click();
        });
      };

      for (
        var _i3 = 0, _accessories3 = accessories;
        _i3 < _accessories3.length;
        _i3++
      ) {
        _loop();
      }

      $("#modern-accessories .modern-accessories").owlCarousel({
        loop: false,
        margin: 10,
        nav: false,
        responsiveClass: true,
        responsive: {
          0: {
            items: 1
          },
          600: {
            items: 2
          }
        }
      });
    };

    var accessoriesReady = setInterval(function() {
      if (
        $("#w3-product-accessories.loaded").length &&
        $("#w3-product-accessories").find(".accessories-item").length
      ) {
        setTimeout(transformAccessories, 1000);
        clearInterval(accessoriesReady);
      }
    }, 100);
  }
});
